import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { Sizes, sizes } from '../media';
export var useCurrentBreakpoint = function () {
  var getBreakpoint = function (windowWidth) {
    var size = Object.keys(sizes).reverse().find(function (bp) {
      return sizes[bp] > windowWidth;
    });
    return size || Sizes.HD;
  };
  var _a = useState(getBreakpoint(window.innerWidth)),
    breakpoint = _a[0],
    setBreakpoint = _a[1];
  var handleWindowResize = useDebouncedCallback(function () {
    return setBreakpoint(getBreakpoint(window.innerWidth));
  }, 250)[0];
  useEffect(function () {
    window.addEventListener('resize', handleWindowResize);
    return function () {
      return window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  return breakpoint;
};